import { render } from "./Chatbar.vue?vue&type=template&id=49974f02&scoped=true"
import script from "./Chatbar.vue?vue&type=script&lang=js"
export * from "./Chatbar.vue?vue&type=script&lang=js"

import "./Chatbar.vue?vue&type=style&index=0&id=49974f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49974f02"]])

export default __exports__